import { PUBLIC_LAYOUT, PUBLIC_MENU_LAYOUT } from '@/constants/layouts'
import { FOOTER_COMPONENT_NAMES } from '@/components/public/footers/index'
import i18n from '@/plugins/i18n'
import { OPENLEGAL_LOGO, OPENLEGAL360_LOGO, ABOGALITYPRO_LOGO } from '@/constants/logosFileNames'
import Area from '@/components/views/openlegal/Area'

const layout = PUBLIC_LAYOUT
const footer = {
  component: FOOTER_COMPONENT_NAMES.OPENLEGAL

}
const logo = {
  src: OPENLEGAL_LOGO
}
const theme = 'openlegal-theme'
const i18nFile = 'public/views/openlegal'
const tagLine = 'Openlegal'

function generateAreasRoutes () {
  // Generate vue routes for every key in areasJson object
  const areasJson = require('@/lang/es/public/views/legal-areas.json')
  const areasRoutes = []
  for (const area in areasJson.openlegal) {
    areasRoutes.push({
      path: `areas/${area}`,
      name: area,
      component: Area,
      meta: {
        tagLine,
        title: {
          text () {
            return i18n.t(`openlegal.${area}.title`)
          }
        },
        layout: PUBLIC_MENU_LAYOUT,
        footer: {
          component: FOOTER_COMPONENT_NAMES.OPENLEGALHOME
        },
        logo,
        theme,
        i18n: 'public/views/legal-areas'
      }
    })
  }
  return areasRoutes
}

export default [
  {
    path: '/',
    name: 'Openlegal',
    component: () => import('@/components/views/openlegal/TemporaryHome'),
    meta: {
      tagLine,
      title: {
        text () {
          return i18n.t('openlegal.title')
        }
      },
      layout,
      footer: {
        component: FOOTER_COMPONENT_NAMES.OPENLEGALHOME
      },
      logo,
      theme,
      i18n: i18nFile
    }
  },
	{
		path: 'legacy',
		name: 'OpenlegalLegacy',
		component: () => import('@/components/views/openlegal/Home'),
		meta: {
      tagLine,
      title: {
        text () {
          return i18n.t('openlegal.title')
        }
      },
      layout,
      footer: {
        component: FOOTER_COMPONENT_NAMES.OPENLEGALHOME
      },
      logo,
      theme,
      i18n: i18nFile
    }
	},
  {
    path: 'openlegal360/empresas',
    name: 'Openlegal360Openlegal',
    component: () => import('@/components/views/openlegal/Vertical'),
    meta: {
      tagLine,
      title: {
        text () {
          return i18n.t('openlegal.title')
        }
      },
      layout,
      footer,
      footer: {
        component: FOOTER_COMPONENT_NAMES.OPENLEGAL360
      },
      logo: {
        src: OPENLEGAL360_LOGO
      },
      theme,
      i18n: i18nFile
    }
  },
  {
    path: 'abogados',
    name: 'Openlegalpro',
    component: () => import('@/components/views/abogalitypro/Home'),
    meta: {
      tagLine,
      title: {
        text () {
          return i18n.t('abogalitypro.title')
        }
      },
      footer: {
        component: FOOTER_COMPONENT_NAMES.ABOGALITYPRO
      },
      logo: {
        src: ABOGALITYPRO_LOGO
      },
      i18n: 'public/views/abogalitypro'
    }
  },
  {
    path: 'terms-clients',
    name: 'TermsClients',
    component: () => import('@/components/views/openlegal/TermsClients'),
    meta: {
      tagLine,
      title: {
        text: 'Términos y condiciones para clientes',
      },
      layout: PUBLIC_MENU_LAYOUT,
      footer,
      logo,
      theme
    }
  },
  {
    path: 'contact/success',
    name: 'ContactFormSuccessOpenlegal',
    component: () => import('@/components/views/CompaniesContactFormSuccess'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      i18n: 'forms/companies-contact-form.json'
    }
  },
  ...generateAreasRoutes(),
  {
    path: 'error-aca',
    name: 'ErrorACA',
    component: () => import('@/components/views/openlegal/OpenlegalACAError'),
    meta: {
      tagLine,
      layout: PUBLIC_MENU_LAYOUT,
      footer,
      logo,
      i18n: 'forms/companies-contact-form.json',
      theme
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/openlegal.routes.js